// import { concat } from 'lodash'
import foldIcon from '../assets/col-fold.png'
import unFoldIcon from '../assets/col-unfold.png'
import { textOverflow } from '@/public/components/kye-canvas-table/utils'
import { runCollapseAnimation, resetCollapseAnimation, collapseType, createDrawCollapseBg } from './collapse-animation'
// headerHeight 为固定表头高度, （多级表头的父级表头高度)
import { cellPaddingWidth, headerHeight } from '@/public/components/kye-canvas-table/config'

const FOLD_ICON = new Image()
FOLD_ICON.src = foldIcon
const UN_FOLD_ICON = new Image()
UN_FOLD_ICON.src = unFoldIcon

const PARENT_HEADER_HEIGHT = headerHeight
const ICON_WIDTH = 14
const ICON_HEIGHT = 14
// let collapseAnimationMoveTimer
let loading = false
let resetDrawTableTimer
let collapseScrollLeftRecode

/**
 *
 * @param {Array} cols
 * @param {Function} callback
 * @description 遍历cols 对cols执行callback
 */
const traverseList = (cols, callback) => {
  for (const col of cols) {
    callback(col)
    if (!col.children) continue
    for (const child of col.children) {
      callback(child)
    }
  }
}

/**
 *
 * @param {Array} cols
 * @param {Function} callback
 * @returns  返回callback(col) 为true的列
 */
const findCol = (cols, callback) => {
  for (const col of cols) {
    if (callback(col)) return col
    if (!col.children) continue
    for (const child of col.children) {
      if (callback(child)) return child
    }
  }
  return null
}


/**
 *
 * @param {*} col
 * @description 返回是否是父级表头
 */
function isParentCol (col) {
  return col.children && col.children.length
}
/**
 *
 * @param {*} param0
 * @description 判断当前列是否添加了collapseKeys属性，需要进行初始化属性操作
 */

function shouldInitCollapsed (col) {
  return col.hasOwnProperty('collapseKeys') && Array.isArray(col.collapseKeys) && col.collapseKeys.length > 0
}


// 判断是否点击折叠icon
const isClickFoldIcon = ({ col, x, y, isHasSort }, vm) => {
  const canvasTable = vm.$refs.table
  const clickX = col.fixed === 'left' ? x : (x + canvasTable.scroll.disx)
  const hotZone = isHasSort ? 0 : 10
  return clickX <= col.x + col.width && clickX >= col.x + col.width - ICON_WIDTH - hotZone - cellPaddingWidth * 2
}

function getColWidth(colWidthMap, col) {
  if (col.width === 'auto') {
    return parseInt(col._autoWidth) || 0
  }
  return parseInt(colWidthMap[col.key] || col.width || 0)
}


/**
 *
 * @param {*} ctx
 * @param {*} colObj
 * @description 绘制右侧icon，在普通表头或者多级表头的一级表头时使用
 */
const createPaintRightFun = (ctx, colObj, tableVm) => {
  const { col, x, y, headerHeight, disx } = colObj
  const { colWidthMap = {} } = tableVm
  return icon => {
    if (!colObj.col.collapseKeys || (Array.isArray(colObj.col.collapseKeys) && colObj.col.collapseKeys.length === 0)) return
    ctx.drawImage(icon, x + col.width - ICON_WIDTH - 2 * cellPaddingWidth, y - cellPaddingWidth, ICON_WIDTH, ICON_HEIGHT)
    const isChild = col._parentkey && col._parent
    const c = {
      w: parseInt(getColWidth(colWidthMap, col)),
      h: isChild ? headerHeight - 32 : headerHeight,
      y: isChild ? 32 : 0,
      x: col.x - disx
    }
    ctx.save()
    ctx.globalAlpha = col.childrenCollapsed === false ? 0.2 : 0
    ctx.fillStyle = col.childrenCollapsed === false ? '#CEC0F4' : ''
    ctx.fillRect(c.x, c.y, c.w, c.h)
    ctx.restore()
  }
}

/**
 *
 * @param {*} ctx
 * @param {*} colObj
 * @description 绘制中间icon,在多级表头的一级表头时使用
 */
const createPaintMiddleFun = (ctx, colObj, tableVm) => {
  const { col, x, y, disx } = colObj
  const { colWidthMap = {} } = tableVm
  return (icon) => {
    if (!colObj.col.collapseKeys || (Array.isArray(colObj.col.collapseKeys) && colObj.col.collapseKeys.length === 0)) return
    const { text } = textOverflow(ctx, col.label, col.width - ICON_WIDTH - 2, 1)
    const tw = Math.floor(ctx.measureText(text).width) || 1
    ctx.fillText(text, x, y + 1)
    ctx.drawImage(icon, x + tw + 2, y - cellPaddingWidth, ICON_WIDTH, ICON_HEIGHT)
    // 绘制控制列
    const c = {
      w: parseInt(getColWidth(colWidthMap, col)),
      h: 32,
      y: 0,
      x: col.x - disx
    }
    // 父级
    if (col.children && col.children.length) {
      c.w = col.children.reduce((v, c) => c.show ? v + parseInt(getColWidth(colWidthMap, c)) : v, 0)
    }
    ctx.save()
    ctx.globalAlpha = col.childrenCollapsed === false ? 0.2 : 0
    ctx.fillStyle = col.childrenCollapsed === false ? '#CEC0F4' : ''
    ctx.fillRect(c.x, c.y, c.w, c.h)
    ctx.restore()
  }
}

/**
 *
 * @param {*} vm table-list 实例
 * @param {*} clickedCol  点击表头
 * @param {*} key  点击表头的key值
 * @description 当前点击列展开或者折叠
 */
function handleCollapse(vm, clickedCol, init) {
  const isInit = init === 'init'
  const key = clickedCol.key
  let curCollapseKes = []
  if (clickedCol.collapsed) {
    // 应该折叠起来的
    const hideKeys = []
    // $disabeldCollapse true，表示字段不能被折叠，即用户使用了个性设置，即show=false
    // $collapse=true 表示字段被折叠
    traverseList(vm.column, col => {
      if (clickedCol.collapseKeys.includes(col.key) && !col.$collapse) {
        col.$disabeldCollapse = col.show === false
        col.$collapse = true
        if (isInit) {
          col.show = false
        }
        hideKeys.push(col.key)
        // 一级头隐藏，二级头需做相应处理
        col.children && col.children.forEach(child => {
          child.$disabeldCollapse = child.show === false
          child.$collapse = true
          if (isInit) {
            child.show = false
          }
          hideKeys.push(child.key)
        })
      }
    })
    if (hideKeys.length > 0) {
      vm._collapsedColsMap[key] = hideKeys
    }
    curCollapseKes = [...(hideKeys || [])]
  } else {
    curCollapseKes = [...(vm._collapsedColsMap[clickedCol.key] || [])]
    delete vm._collapsedColsMap[clickedCol.key]
    traverseList(vm.column, col => {
      if (clickedCol.collapseKeys.includes(col.key)) {
        col.$collapse = false
        // 一级头展示，二级头需做相应处理
        col.children && col.children.forEach(child => {
          child.$collapse = false
        })
      }
    })
  }
  if (!isInit) {
    // clearTimeout(collapseAnimationMoveTimer)
    runCollapseAnimation(clickedCol, curCollapseKes, vm)
    if (vm.options.collapsed && typeof vm.options.collapsed === 'function') {
      const o = {
        key: clickedCol.key,
        collapsed: !clickedCol.collapsed,
        column: clickedCol
      }
      vm.options.collapsed(o)
    }
  }
}

// 根据画布位置设置滚动条位置
function setScrollLeft(left, tableVm, disx) {
  return new Promise(resolve => {
    tableVm.$nextTick(() => {
      const { hScrollbar, horizontal, canvas, canvasConfig } = tableVm
      const overWidth = canvasConfig.aw - canvas.offsetWidth
      const disW = horizontal.offsetWidth - hScrollbar.offsetWidth
      let left = parseInt((disx / overWidth) * disW) + 'px'
      hScrollbar.style.left = left
      resolve(left)
    })
  })
}

export function resetDrawTable(vm, init, type) {
  const {
    scroll,
    integrateData1,
    integrateData,
    getDisplayRow,
    getDisplayCol,
    handleShowText,
    draw,
    initScroll,
    clearCurrentChange,
    canvas,
    canvasConfig,
    hScrollbar,
    horizontal,
  } = vm.$refs.table
  const oldX = scroll.disx
  if (init === true) {
    const origScrollLeft = parseInt(hScrollbar.style.left)
    clearTimeout(resetDrawTableTimer)
    clearCurrentChange()
    integrateData(true)
    // 重置滚动条
    initScroll()
    // 快速设置回之前滚动条样子
    setScrollLeft(origScrollLeft, vm.$refs.table, oldX).then(left => {
      collapseScrollLeftRecode = left
    })
    resetDrawTableTimer = setTimeout(() => {
      resetCollapseAnimation(vm)
      // 边界判断
      const canvasOW = canvas.offsetWidth
      const overWidth = canvasConfig.aw - canvasOW
      const hScrollbarOW = hScrollbar.offsetWidth
      const horizontalOW = horizontal.offsetWidth
      // 超出兜底
      const disxOverstep = oldX > overWidth
      // 滚动条在最右边，但是画布却不是在右边
      const scrollBarSumWidth = hScrollbarOW + collapseScrollLeftRecode
      const isUpdateScroll = (scrollBarSumWidth === horizontalOW || scrollBarSumWidth > horizontalOW) && oldX < overWidth
      if (disxOverstep || isUpdateScroll) {
        vm.$refs.table.setTableColumns()
        vm.setScrollLeft(vm._scrollLeft)
      }
    }, type === collapseType.expand ? 1200 : 0)
  } else {
    // 耗时优化，使用简易循环
    integrateData1(true)
  }
  scroll.disx = oldX
  getDisplayRow()
  getDisplayCol()
  init === true && handleShowText()
  draw()
}

// 给columns 添加collapsed属性,并添加自定义绘制头部属性
function initColumnCollapsed (vm) {
  const headRenderOptions = {}
  // const canCollapseColumnMaps = getCollapseColumnMaps(vm.column, true)
  // 判断是否已经折叠过了，用于个性设置的判断
  const hasCollapsedCols = Object.keys(vm._collapsedColsMap)
  traverseList(vm.column, col => {
    if (!shouldInitCollapsed(col)) {
      // 存在历史数据
      if (vm.headRenderOptions[col.key] && vm.headRenderOptions[col.key]._internal === true) {
        delete vm.headRenderOptions[col.key]
      }
      return
    }
    // 个性设置保存时，判断列是否被折叠，如果折叠，则需重新触发折叠功能，隐藏字段
    col.collapsed = hasCollapsedCols.includes(col.key) || col.collapsed || false

    // 默认折叠
    if (col.collapsed) {
      const _init = 'init'
      handleCollapse(vm, col, _init)
    }

    col.customHeaderClick = true

    // 存在被控制列被个性化隐藏问题
    // if (col.collapseKeys.every(key => (!canCollapseColumnMaps[key]))) {
    //   if (vm.headRenderOptions[col.key] && vm.headRenderOptions[col.key]._internal === true) {
    //     delete vm.headRenderOptions[col.key]
    //   }
    //   return
    // }

    // 做兼容处理，如果用户自定义了headRenderOptions,直接返回
    if (vm.headRenderOptions[col.key]) {
      return
    }

    if (isParentCol(col)) {
      headRenderOptions[col.key] = (ctx, colObj) => {
        const paintFun = createPaintMiddleFun(ctx, colObj, vm.$refs.table)
        paintFun(colObj.col.collapsed ? UN_FOLD_ICON : FOLD_ICON)
      }
      headRenderOptions[col.key]._internal = true
    } else {
      headRenderOptions[col.key] = {
        reRender: (ctx, colObj) => {
          if (colObj.col.width < 20) return
          const paintFun = createPaintRightFun(ctx, colObj, vm.$refs.table)
          paintFun(colObj.col.collapsed ? UN_FOLD_ICON : FOLD_ICON)
        }
      }
    }
  })
  Object.assign(vm.headRenderOptions, headRenderOptions)
}

function handleHeaderClick(vm, { col, sortFunc, x, y }) {
  if (!shouldInstall(vm)) return

  // 无数据不支持折叠
  if (vm.data && vm.data.length === 0) return

  // 如果 y<= 32 点击的是一级头部
  const clickedCol = y <= PARENT_HEADER_HEIGHT && col._parentkey ? col._parent : col
  const key = clickedCol.key
  const originCol = findCol(vm.column, item => item.key === key)

  if (!clickedCol.collapseKeys) return
  // 是否存在排序
  const isHasSort = clickedCol && Array.isArray(clickedCol.sortKeys) && clickedCol.sortKeys.length === 2
  // 如果不是多级表头的头部，并且点击的不是折叠icon，排序，不折叠
  if (!isParentCol(clickedCol) && !isClickFoldIcon({ col: clickedCol, x, y, isHasSort }, vm)) {
    sortFunc && sortFunc()
    return
  }

  const canCollapseColumnMaps = getCollapseColumnMaps(vm.column)
  if ((originCol.collapseKeys || []).every(key => (!canCollapseColumnMaps[key]))) {
    return vm.$message && vm.$message.warning('当前所有被控制列均被隐藏')
  }

  originCol.collapsed = !originCol.collapsed
  originCol.childrenCollapsed = originCol.collapsed === true
  // 进行折叠操作
  handleCollapse(vm, originCol)
  vm.$emit('collapsed', {key, column: col, collapsed: originCol.collapsed})
}

// function handleHeaderMove(vm, { col, x, y }) {
//   if (!shouldInstall(vm)) return
//   if (vm.data && vm.data.length === 0) return
//   // 如果 y<= 32 点击的是一级头部
//   const clickedCol = y <= PARENT_HEADER_HEIGHT && col._parentkey ? col._parent : col
//   if (!clickedCol.collapseKeys) return
//   const key = clickedCol.key
//   const originCol = findCol(vm.column, item => item.key === key)
//   // 如果不是多级表头的头部，并且点击的不是折叠icon，排序，不折叠
//   if (!isParentCol(clickedCol) && !isClickFoldIcon({ col: clickedCol, x, y }, vm)) {
//     resetCollapseAnimation(vm)
//     return
//   }
//   let height = vm.$refs.table.headerHeight
//   if (originCol.children && originCol.children.length) {
//     height = 32
//   }
//   if (col._parent) {
//     height -= 32
//     y -= 32
//   }
//   height = Math.floor((height - ICON_HEIGHT) / 2)
//   if (y > (height + ICON_HEIGHT) || y < height) {
//     resetCollapseAnimation(vm)
//     return
//   }
//   clearTimeout(collapseAnimationMoveTimer)
//   // 被折叠了就不管了
//   if (originCol.collapsed) return
//   collapseAnimationMoveTimer = setTimeout(() => {
//     runCollapseAnimation(clickedCol, originCol.collapseKeys, vm, 'hover')
//   }, 10)
// }

// isInit是为了判断在初始化时候做处理
function getCollapseColumnMaps(columns = [], isInit) {
  return columns.reduce((c, column) => {
    let { $disabeldCollapse, key, children } = column
    // 子级采集
    if (children && children.length) {
      children.forEach(_column => {
        let { $disabeldCollapse } = _column
        if (isInit) {
          if (_column.show && _column.$show && $disabeldCollapse) {
            $disabeldCollapse = false
          } else if (!_column.show && !_column.$show) {
            $disabeldCollapse = true
          }
        }
        if (!$disabeldCollapse) {
          c[_column.key] = true
        }
      })
    }
    // $disabeldCollapse字段在点击收起折叠做的处理
    if (isInit) {
      if (column.show && column.$show && $disabeldCollapse) {
        $disabeldCollapse = false
      } else if (!column.show && !column.$show) {
        $disabeldCollapse = true
      }
    }
    if (!$disabeldCollapse) {
      c[key] = true
    }
    return c
  }, {})
}

function handleScroll (vm, e) {
  vm._scrollLeft = e.scrollLeft
  resetCollapseAnimation(vm)
}

// 初始化非响应式数据，记录哪个列折叠
function createData (vm) {
  vm._collapsedColsMap = {}
  // 记录横向滚动距离
  vm._scrollLeft = 0
  initColumnCollapsed(vm)
}

function createEvent(vm) {
  vm.$on('table-scroll', e => handleScroll(vm, e))
  vm.$refs.table.$on('header-click', (e) => {
    if (!loading) {
      try {
        loading = true
        setTimeout(() => {
          loading = false
        }, 600)
        handleHeaderClick(vm, e)
      } catch (e) {
        console.log(3, e)
      }
    } else {
      console.log('计算处理111')
    }
  })

  // vm.$refs.table.$on('header-move', e => handleHeaderMove(vm, e));
  // ['table-leave', 'any-cell-move'].forEach(name => {
  //   vm.$refs.table.$on(name, () => {
  //     clearTimeout(collapseAnimationMoveTimer)
  //     resetCollapseAnimation(vm)
  //   })
  // })
}

function createWatch (vm) {
  vm.$watch(() => vm.column, (val) => {
    validateKeys(vm)
    // 判断执行安装逻辑
    if (!shouldInstall(vm)) return
    initColumnCollapsed(vm)
    createDrawCollapseBg(vm)
    // 个性设置时保持折叠状态
    vm.$refs.table.setTableColumns()
  })
}

// 是否应该执行安装逻辑
function shouldInstall (vm) {
  return findCol(vm.column, col => shouldInitCollapsed(col))
}

// 校验错误信息
function validateKeys (vm) {
  const allKeys = new Set()
  traverseList(vm.column, col => {
    allKeys.add(col.key)
  })
  traverseList(vm.column, col => {
    if (!col.hasOwnProperty('collapseKeys')) return
    if (!Array.isArray(col.collapseKeys)) {
      console.info(`[query-table]: ${col.key} 的collapseKeys属性必须是数组!`)
      return
    }
    col.collapseKeys.map(key => {
      if (!allKeys.has(key)) {
        console.info(`[query-table]:${col.key}下collapseKeys的${key}不存在`)
      }
    })
  })
}

function tableHeaderPlugin (vm) {
  // table 不存在时返回
  if (!vm.$refs.table) return
  validateKeys(vm)
  createData(vm)
  createEvent(vm)
  createWatch(vm)
  if (shouldInstall(vm)) {
    createDrawCollapseBg(vm)
  }
}


export default tableHeaderPlugin



// WEBPACK FOOTER //
// ./src/public/components/query-table/module/table-header-plugin.js